export default __webpack_public_path__ + "static/Kuball_Katalog_cover-1534e22c17353e6729b425e5324ee7e2.jpg";